export default __webpack_public_path__ + "static/media/aria_delta.3d498f7b.png";